
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/priority-lists",
      function () {
        return require("private-next-pages/customer-studio/priority-lists.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/priority-lists"])
      });
    }
  